import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAddresses = async (userId: string | undefined) => {
    const { data, error } = await supabase
        .from('user_shippings')
        .select(`*, user(*)`)
        .eq('user', userId)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetShippingAddress(userId: string | undefined) {
    return useQuery({
        queryKey: ['useGetShippingAddress', userId],
        queryFn: () => getAddresses(userId),
        staleTime: 0,
        enabled: !!userId
    })
}
